import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1757995628406'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='10964'
        width='200'
        height='200'
    >
        <path
            d='M224.304762 531.504762h175.542857v78.019048H224.304762zM624.152381 531.504762h175.542857v78.019048h-175.542857z'
            p-id='10965'
            fill='currentColor'
        ></path>
        <path
            d='M1019.12381 292.571429h-146.285715l-112.152381-170.666667H258.438095L146.285714 292.571429H4.87619v97.523809h78.019048L19.504762 482.742857c-4.87619 9.752381-4.87619 19.504762-4.876191 29.257143v385.219048H341.333333V780.190476h355.961905l-4.87619 117.028572h321.828571v-385.219048c0-9.752381 0-19.504762-4.87619-29.257143L941.104762 390.095238H1024V292.571429zM312.07619 224.304762h399.84762l82.895238 126.780952H229.180952l82.895238-126.780952z m472.990477 575.390476l4.87619-117.028571H234.057143v117.028571H107.27619v-273.066667l53.638096-78.019047h697.295238l53.638095 78.019047v273.066667h-126.780952z'
            p-id='10966'
            fill='currentColor'
        ></path>
    </svg>
)

export const VehicleIcon = props => <Icon component={SVG} {...props} />
